<template>
  <div id="pageRomaneios">
    <v-row class="my-5">
      <v-btn
        class="btn-add"
        color="white"
        large
        right
        absolute
        fab
        @click="openModalDialog()"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-row>

    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-circular>
      </div>

      <div v-show="!loading">
        <v-card>
          <v-card-text>
            <v-data-table
              v-if="users.data"
              :headers="headers"
              :items="users.data"
              :mobile-breakpoint="960"
              disable-pagination
              hide-default-footer
              disable-sort
              class="animals-table"
            >
              <template v-slot:item.accesses="{ item }">
                <v-btn
                  color="primary"
                  :disabled="item.tokens && item.tokens.length === 0"
                  @click="openUserAccessDialog(item)"
                >
                  {{ (item.tokens && item.tokens.length) || 0 }}
                </v-btn>
              </template>
              <template v-slot:item.created_at="{ item }">{{
                item.created_at | formatDateHour
              }}</template>

              <template v-slot:item.actions="{ item }">
                <v-row align-content="center">
                  <v-btn
                    small
                    icon
                    color="primary"
                    @click="openModalDialog(item)"
                  >
                    <v-icon>fa-edit</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    class="ml-1"
                    @click="deleteUserRequest(item)"
                    small
                    icon
                    color="error"
                  >
                    <v-icon>fas fa-trash-alt</v-icon>
                  </v-btn> -->
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <app-pagination
          v-if="users && users.pagination"
          :pagination="users.pagination"
          :disabled="paginatationDisabled"
          v-on:change-page="searchUsers"
        ></app-pagination>
      </div>

      <app-confirm-modal></app-confirm-modal>

      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="dialogs.deleteUser.show"
          max-width="600px"
        >
          <v-card>
            <v-card-title class="error white--text" primary-title>
              <span class="headline">Atenção!</span>
            </v-card-title>
            <v-card-text
              ><v-row class="py-3">
                Você realmente deseja excluir o usuário
                <b class="mx-1">{{ userToDelete.name }}</b
                >?
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="deleteUserSuccess">
                Sim
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogs.deleteUser.show = false"
                >Não</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogs.modalUser.show" max-width="800px">
          <v-card>
            <v-card-title class="primary white--text" primary-title>
              <span class="headline"
                >{{ user.id ? "Editar" : "Adicionar" }} Usuário</span
              >
            </v-card-title>
            <v-card-text class="px-11">
              <v-row class="py-1">
                <v-text-field
                  v-model="user.name"
                  :error="form.user.name.error"
                  :error-messages="form.user.name.message"
                  @keyup="form.user.name = { error: false, message: '' }"
                  label="Nome"
                  type="text"
                ></v-text-field>
              </v-row>
              <v-row class="py-1">
                <v-text-field
                  v-model="user.login"
                  :error="form.user.login.error"
                  :error-messages="form.user.login.message"
                  @keyup="form.user.login = { error: false, message: '' }"
                  label="Login"
                  type="login"
                ></v-text-field>
              </v-row>
              <v-row class="py-1">
                <v-text-field
                  v-model="user.password"
                  :error="form.user.password.error"
                  :error-messages="form.user.password.message"
                  @keyup="form.user.password = { error: false, message: '' }"
                  label="Senha"
                  type="password"
                ></v-text-field>
              </v-row>
              <v-row class="py-1">
                <v-text-field
                  v-model="user.partner"
                  :error="form.user.partner.error"
                  :error-messages="form.user.partner.message"
                  @keyup="form.user.partner = { error: false, message: '' }"
                  label="Parceiro"
                  type="text"
                ></v-text-field>
              </v-row>

              <v-row class="mt-3">
                <v-select
                  @change="addDocumentationToUser"
                  :items="inputDocumentations"
                  label="Documentações"
                  item-value="id"
                  item-text="name"
                ></v-select>
              </v-row>

              <v-data-table
                :headers="headersDocumentationsAccess"
                :items="user.documentations"
                :mobile-breakpoint="960"
                disable-pagination
                hide-default-footer
                disable-sort
                class="animals-table"
              >
                <template v-slot:item.status="{ item }">
                  <v-switch v-model="item.status" :value="item.status">
                  </v-switch>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    class="ml-1"
                    @click="removeDocumentationAccess(item.id)"
                    small
                    icon
                    color="error"
                  >
                    <v-icon>fas fa-trash-alt</v-icon>
                  </v-btn>

                  <!-- <v-switch :value="item.status"> </v-switch> -->
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :loading="savingUser"
                color="green darken-1"
                text
                @click="saveUser"
              >
                {{ user.id ? "Salvar" : "Cadastrar" }}
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogs.modalUser.show = false"
                >Cancelar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="dialogs.userAccesses.show" max-width="1000px">
          <v-card>
            <v-card-title class="primary white--text" primary-title>
              <span class="headline"
                >Acessos do Usuário {{ userSelected.name }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headersTokens"
                :items="userSelected.tokens"
                :mobile-breakpoint="960"
                disable-pagination
                hide-default-footer
                disable-sort
                class="animals-table"
              >
                <template v-slot:item.created_at="{ item }">{{
                  item.created_at | formatDateHour
                }}</template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogs.userAccesses.show = false"
                >Fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import api from "../../../plugins/documentationsApi";
import AppPagination from "../../../components/Pagination";
import ConfirmModal from "../../../components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      form: {
        user: {
          name: {
            error: false,
            message: ""
          },
          password: {
            error: false,
            message: ""
          },
          login: {
            error: false,
            message: ""
          },
          partner: {
            error: false,
            message: ""
          }
        }
      },

      loading: true,
      user: {
        name: "",
        password: "",
        login: "",
        partner: "",
        name: "",
        documentations: []
      },

      baseDocumentations: [],
      inputDocumentations: [],
      userDocumentationsAccess: [],

      headers: [
        { text: "Id", value: "id", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "E-mail", value: "login", sortable: false },
        { text: "Parceiro", value: "partner", sortable: false },
        { text: "Acessos", value: "accesses", sortable: false },
        { text: "Data cadastro", value: "created_at", sortable: false },
        { text: "Ações", value: "actions", sortable: false }
      ],
      headersTokens: [
        { text: "IP", value: "user_ip", sortable: false },
        { text: "Browser", value: "user_agent", sortable: false },
        { text: "Documentação", value: "user_origin", sortable: false },
        { text: "Data de acesso", value: "created_at", sortable: false }
      ],
      headersDocumentationsAccess: [
        { text: "Nome", value: "name", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Ações", value: "actions", sortable: false }
      ],

      users: {},
      savingUser: false,
      userSelected: {},
      currentPage: 1,
      password: null,
      paginatationDisabled: false,
      dialogs: {
        modalUser: { show: false },
        deleteUser: { show: false },
        updateUser: { show: false },
        userAccesses: { show: false }
      },
      snackbar: {},
      searchData: {},
      userToDelete: {}
    };
  },

  computed: {},

  mounted: async function() {
    window.scrollTo(0, 0);

    if (this.$route.query.page)
      this.searchData["page"] = this.$route.query.page;
    else this.searchData["page"] = 1;

    await this.getDocumentations();

    await this.getUsers(this.searchData);
  },

  methods: {
    addDocumentationToUser(documentationId) {
      const documentationIndex = this.inputDocumentations.findIndex(
        e => e.id === documentationId
      );

      if (documentationIndex > -1) {
        this.user.documentations.push(
          this.inputDocumentations[documentationIndex]
        );
        this.inputDocumentations.splice(documentationIndex, 1);
      }
    },

    async getDocumentations() {
      const { data: res } = await api.getDocumentations({
        page: 1,
        perPage: 999
      });

      this.inputDocumentations = res.data.map(e => {
        return { ...e, status: true };
      });
    },

    openUserAccessDialog(user) {
      this.dialogs.userAccesses.show = true;
      this.userSelected = user;
    },

    async saveUser() {
      this.savingUser = true;
      const method = this.user.id ? "updateUser" : "createUser";

      try {
        const { data: user } = await api[method](this.user);

        for (const doc of this.user.documentations) {
          await api.createUserDocumentationAccess({
            user_id: user.id,
            documentation_id: doc.id,
            status: doc.status
          });
        }

        await this.getUsers(this.searchData);

        this.snackbar = {
          show: true,
          color: "success",
          text: "Usuário salvo com sucesso"
        };
        this.dialogs.modalUser.show = false;

        this.savingUser = false;
      } catch (err) {
        this.handleError();
        if (err.response && err.response.data) {
          for (const e of err.response.data.fields) {
            this.form.user[e.path].error = true;
            this.form.user[e.path].message = e.message;
          }
        }
      }
    },

    async removeDocumentationAccess(documentationId) {
      const documentationIndex = this.user.documentations.findIndex(
        e => e.id === documentationId
      );

      if (documentationIndex > -1) {
        if (this.user.documentations[documentationIndex].id) {
          await api.revokeUserDocumentationAccess({
            user_id: this.user.id,
            documentation_id: documentationId
          });
        }

        this.inputDocumentations.push(
          this.user.documentations[documentationIndex]
        );
        this.user.documentations.splice(documentationIndex, 1);
      }
    },

    handleError(err) {
      console.log(err);

      this.snackbar = {
        show: true,
        color: "error",
        text: "Erro ao salvar usuário"
      };
    },

    searchUsers: function(page) {
      let data = { page: page ? page : 1 };
      this.$router.push({ name: "Documentations", query: data });
    },

    deleteUserRequest(user) {
      this.dialogs.deleteUser.show = true;

      this.userToDelete = user;
    },

    async openModalDialog(
      user = {
        name: "",
        password: "",
        login: "",
        partner: "",
        documentations: []
      }
    ) {
      this.user = user;

      await this.getDocumentations();

      console.log(user);
      user.documentations = user.documentations ? user.documentations : [];

      user.documentations = user.documentations.map(relation => {
        const { documentation: d } = relation;

        if (d) {
          const foundIndex = this.inputDocumentations.findIndex(
            e => e.id === d.id
          );

          if (foundIndex > -1) this.inputDocumentations.splice(foundIndex, 1);
          return { ...d, status: relation.status };
        }
      });

      this.dialogs.modalUser.show = true;
    },

    getUsers: async function(data) {
      this.paginatationDisabled = true;
      const { data: users } = await api.getUsers(data).catch(error => {
        console.log("error", error);
      });

      this.loading = false;

      this.users = users || [];
    },

    deleteUserSuccess(answer) {
      api
        .deleteUser(this.userToDelete.id)
        .then(() => {
          this.snackbar = {
            show: true,
            color: "success",
            text: "Usuário deletado com sucesso"
          };

          const userIdxToDel = this.users.data.findIndex(item => {
            return item.id === this.userToDelete.id;
          });

          this.users.data.splice(userIdxToDel, 1);
          this.dialogs.deleteUser.show = false;
        })
        .catch(err => {
          if (err.response && err.response.data) {
            for (const e of err.response.data) {
              this.form.deleteUser[e.field].error = true;
              this.form.deleteUser[e.field].message = e.message;
            }
          }
        });
    }
  }
};
</script>
<style scoped lang="css">
>>> .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

>>> .v-data-table-header tr th {
  min-width: 150px;
}


.cardtitle{
max-width: 90%;
}
</style>
